import { VersionData } from "@models/version-data.model";

export class CustomerCardGeneratorRequest {
    numberOfCards: number;
    programMobileAppId: number;
    versionData: VersionData;
}